import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-653acad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex mb-4 flex-column flex-lg-row justify-content-between align-items-center" }
const _hoisted_2 = { class: "d-flex w-100 mb-4 mb-lg-0 justify-content-center" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-decoration-none text-black" }
const _hoisted_5 = { class: "icon-box position-relative mb-2" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "text text-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caret text-center position-absolute" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down" })
], -1))

import { computed, ref, watch } from 'vue'
import { NAVES } from '@/constants/index'
import { cloneDeep } from 'lodash'
import { useStore } from 'vuex'
import { COMMUNITY_STORE } from '@/store/constants'
import { CommunityStateTypes } from '@/store/modules/community'


export default /*#__PURE__*/_defineComponent({
  props: {
  content_type: {
    type: Number,
  },
  hasThreeTabs: Boolean,
  showType: Number,
},
  emits: ['setContentType'],
  setup(__props, { emit }) {

const props = __props



const store = useStore()


const profileCommunity = computed<CommunityStateTypes>(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO])

const content_type = ref(1)
watch(
  () => props.content_type,
  () => {
    content_type.value = cloneDeep(props.content_type)
  },
  { deep: true }
)

const naves = computed(() => {
  if (props.hasThreeTabs) {
    return NAVES.slice(1, 4)
  }
  if (props.showType === 1) return NAVES.slice(1, 2)
  if (props.showType === 2) return NAVES.slice(2, 3)

  // 投稿許可設定変更
  if (profileCommunity.value?.post_article_permission && profileCommunity.value?.post_recruitment_permission) return NAVES.slice(1, 3)
  if (profileCommunity.value?.post_article_permission) return NAVES.slice(1, 2)
  if (profileCommunity.value?.post_recruitment_permission) {
    return NAVES.slice(2, 3)
  }

  return NAVES.slice(1, 3)
})

const changeTab = (navID: number): void => {
  content_type.value = navID
  emit('setContentType', navID)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(naves), (nav) => {
        return (_openBlock(), _createElementBlock("li", {
          onClick: ($event: any) => (changeTab(nav.query.content_type)),
          key: nav.id,
          class: _normalizeClass(['position-relative px-lg-5 cursor-pointer', content_type.value === nav.query.content_type || _unref(naves)?.length === 1 ? 'active' : ''])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: nav.icon,
                class: "icon",
                alt: nav.query
              }, null, 8, _hoisted_6),
              _createElementVNode("img", {
                src: nav.iconHover,
                class: "icon icon--hover",
                alt: nav.query
              }, null, 8, _hoisted_7),
              _createElementVNode("img", {
                src: nav.iconActive,
                class: "icon icon--active",
                alt: nav.query
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(nav.title), 1),
            _hoisted_10
          ])
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})